<template lang="pug">
#bloco-dados-relatorio-rastreabilidade
    h3 {{ $t('mensagens.relatorioRastreabilidade.cadastro.dadosRelatorio') }}
    el-card.dados-relatorio-rastreabilidade__card
        el-form.col-12(
            label-position='top',
            :model='formCadastroManual',
            :rules='formCadastroManualRegras',
            ref='formCadastroManualRef'
        )
            .row.dados-relatorio-rastreabilidade__linha
                el-form-item.dados-relatorio-rastreabilidade__item(
                    :label='$t("mensagens.relatorioRastreabilidade.comuns.numeroContrato")',
                    prop='numeroContrato'
                )
                    el-input#numeroContrato(
                        v-model.number='formCadastroManual.numeroContrato',
                        :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.digitarNumeroContrato")',
                        maxlength='10'
                    )

                el-form-item.dados-relatorio-rastreabilidade__item(
                    :label='$t("mensagens.relatorioRastreabilidade.comuns.cultura")',
                    prop='nomeCultura'
                )
                    el-select#cultura(
                        v-model='formCadastroManual.nomeCultura',
                        clearable,
                        filterable,
                        :disabled='bloquearEdicao',
                        :loading='loading.culturas',
                        :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.selecione")'
                    )
                        el-option(
                            v-for='({ nome, id, nomeTraduzido }, index) in opcoes.culturas',
                            :key='id + nome',
                            :id='"cultura-" + nome',
                            :label='nomeTraduzido',
                            :value='nome'
                        )

                el-form-item.dados-relatorio-rastreabilidade__item(
                    :label='$t("mensagens.relatorioRastreabilidade.cadastro.volumeContratoT")',
                    prop='volumeContrato'
                )
                    el-input#volumeContrato(
                        :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.digiteVolume")',
                        v-model='formCadastroManual.volumeContrato'
                    )
</template>
<script>
import CulturaService from '@/services/CulturaService';
import i18n from '@/main';

export default {
    name: 'BlocoInserirDadosRelatorio',

    props: {
        bloquearEdicao: {
            type: Boolean,
            default: false
        },
        dadosEdicao: {
            type: Object,
            required: false
        }
    },

    components: {},

    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
                        )
                    )
                );
                return;
            }

            if (value.toString().length !== 10) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.numeroContratoDeveConterDezNumeros'
                        )
                    )
                );
                return;
            }

            const apenasNumeros = /^\d*$/;
            if (!apenasNumeros.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.numeroContratoDeveConterApenasNumeros'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
                        )
                    )
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.naoPodeHaverPontos'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.numeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.valorNaoAceito'
                        )
                    )
                );
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.valorDeveSerMaiorQueZero'
                        )
                    )
                );
                return;
            }

            callback();
        };

        return {
            formCadastroManual: {
                numeroContrato: '',
                nomeCultura: '',
                volumeContrato: ''
            },
            formCadastroManualRegras: {
                numeroContrato: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'blur'
                    }
                ],
                nomeCultura: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
                        ),
                        trigger: 'change'
                    }
                ],
                volumeContrato: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ]
            },

            opcoes: {
                culturas: []
            },

            loading: {
                culturas: true
            }
        };
    },

    computed: {
        locale: function () {
            return i18n._vm.locale;
        }
    },

    mounted() {
        this.buscarCultura();
    },

    watch: {
        dadosEdicao: {
            handler() {
                if (this.dadosEdicao) {
                    this.preencherCamposParaEdicao();
                }
            },
            immediate: true
        },
        'formCadastroManual.numeroContrato': function (
            newNumeroContrato,
            oldNumeroContrato
        ) {
            if (newNumeroContrato !== oldNumeroContrato) {
                this.enviarDadosRelatorio();
            }
        },
        'formCadastroManual.nomeCultura': function (
            newNomeCultura,
            oldNomeCultura
        ) {
            if (newNomeCultura !== oldNomeCultura) {
                this.enviarDadosRelatorio();
            }
        },
        'formCadastroManual.volumeContrato': function (
            newVolumeContratado,
            oldVolumeContratado
        ) {
            if (newVolumeContratado !== oldVolumeContratado) {
                this.enviarDadosRelatorio();
            }
        },
        '$i18n._vm.locale': function () {
            this.buscarCultura();
            this.formCadastroManualRegras.nomeCultura[0].message = this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
            );
        }
    },

    methods: {
        async buscarCultura() {
            try {
                this.loading.culturas = true;
                const { data } = await CulturaService.buscarCultura(false);

                this.opcoes.culturas = data.filter(
                    item => item.nome === 'Soja' || item.nome === 'Milho'
                );
                this.loading.culturas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.erroBuscarCulturas'
                    )
                );
            }
        },
        enviarDadosRelatorio() {
            var dadosRelatorio = {
                numeroContrato: this.formCadastroManual.numeroContrato,
                volumeContrato: this.formCadastroManual.volumeContrato,
                nomeCultura: this.formCadastroManual.nomeCultura
            };
            this.$emit('dadosRelatorio', dadosRelatorio);
        },

        validateForm() {
            this.$refs['formCadastroManualRef'].validate(valid => {
                if (valid) {
                } else {
                    this.$emit('handleValidationFailed');
                }
            });
        },

        preencherCamposParaEdicao() {
            this.formCadastroManual.numeroContrato =
                this.dadosEdicao.numeroContrato;
            this.formCadastroManual.nomeCultura = this.dadosEdicao.nomeCultura;
            this.formCadastroManual.volumeContrato =
                this.dadosEdicao.volumeContrato;
        }
    }
};
</script>
<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
#bloco-dados-relatorio-rastreabilidade {
    h3 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }
    .el-card__body {
        padding: 16px;
    }
    .row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin-right: -15px;
        margin-left: -15px;
        justify-content: space-between;
        gap: 16px;

        .el-form-item {
            margin-bottom: 8px;
            flex: 1;

            .el-select {
                display: flex;
                position: relative;
            }
        }
    }
}
</style>
